import { FORGOT_PASSWORD } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case FORGOT_PASSWORD.LOAD:
      return {
        ...state,
        loading: true
      };
    case FORGOT_PASSWORD.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case FORGOT_PASSWORD.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
